<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" style="transform: scale(1.25)">
    <g>
		<path
			d="M12.44,3c9,0,14.79,10.64,10.9,18.66a12,12,0,0,1-16,6.27,12.16,12.16,0,0,1-6.14-6.27C-2.72,13.53,3.28,2.72,12.44,3Zm-.27,3.67c-6.4-.06-10.66,7.69-7.82,13.4a8.62,8.62,0,0,0,11.48,4.47,8.78,8.78,0,0,0,4.39-4.47C23.08,14.28,18.68,6.44,12.17,6.68Z"
			style="opacity:0.5;isolation:isolate" />
		<path
			d="M19.88,3c9,0,14.77,10.64,10.89,18.66a12,12,0,0,1-16,6.27,12.22,12.22,0,0,1-6.15-6.27C4.72,13.53,10.67,2.72,19.88,3ZM19.6,6.68C13.21,6.62,9,14.37,11.78,20.08a8.63,8.63,0,0,0,11.48,4.47,8.74,8.74,0,0,0,4.39-4.47C30.51,14.28,26.12,6.44,19.6,6.68Z" />
	</g>
</svg>
